module.exports = __webpack_public_path__ + "static/media/HAUX_MAIS_VIDA_6.0491e41a.pdf";